export const AutentificacaoLogin = {
    // Letra A:
    // Letra B:
    // Letra C:
    // Letra D:
    // Letra E:
    ESQUECEU_SENHA: 'Esqueceu sua senha?',
    EMAIL: 'E-mail',

    // Letra F:
    // Letra G:
    // Letra H:
    // Letra I:
    // Letra J:
    // Letra K:
    // Letra L:
    LOGIN: 'Login',

    // Letra M:
    // Letra N:
    // Letra O:
    // Letra P:
    // Letra Q:
    // Letra R:
    // Letra S:
    SENHA: 'Senha',

    // Letra T:
    // Letra U:
    // Letra V:
    // Letra X:
    // Letra Y:
    // Letra Z:
}